import { configureStore } from "@reduxjs/toolkit";
import sessionReducer from "./sessionSlice";
import qaReducer from "./qualityAlertSlice";
import approvalReducer from './approvalSlice';
import supplierReducer from './supplierSlice';
import locationReducer from './locationSlice';
import analyticsReducer from './analyticsSlice';
import notificationReducer from './notificationSlice';
import attachmentReducer from './attachmentSlice';
import profileReducer from './profileSlice';

export const store = configureStore({
  reducer: {
    session: sessionReducer,
    qa: qaReducer,
    approvals: approvalReducer,
    supplier: supplierReducer,
    location: locationReducer,
    analytics: analyticsReducer,
    notification: notificationReducer,
    attachment: attachmentReducer,
    profile: profileReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Add typed hooks
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
